module.exports = __webpack_public_path__ + "static/media/corner-left-down.0ac1bf3a.svg";